import React, { useCallback } from 'react';

import { usePaginationFromURL } from 'hooks/usePaginationFromURL';

import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

import { OrderFilterKey } from '../constant';

interface OrderTabsProps {
    handleUpdateParam: (key: string, value: string) => void;
}

export const OrderTabs: React.FC<OrderTabsProps> = ({ handleUpdateParam }) => {
    const urlParams = usePaginationFromURL('orders');
    const isFreeParam = urlParams.isFree;

    // Default to paid orders (false) if not specified
    const currentTab = isFreeParam === 'true' ? 'free' : 'paid';

    const handleTabChange = useCallback((value: string) => {
        const isFree = value === 'free' ? 'true' : 'false';
        handleUpdateParam(OrderFilterKey.IS_FREE, isFree);
    }, [handleUpdateParam]);

    return (
        <Tabs value={currentTab} onValueChange={handleTabChange} className="w-full">
            <TabsList className="h-auto bg-transparent border-b border-gray-200 rounded-none p-0 justify-start">
                <TabsTrigger
                    value="paid"
                    className="rounded-none border-b-2 border-transparent data-[state=active]:border-indigo-600 data-[state=active]:bg-transparent data-[state=active]:shadow-none bg-transparent px-4 py-3 text-gray-500 data-[state=active]:text-indigo-600 font-normal data-[state=active]:font-semibold"
                >
                    Paid Orders
                </TabsTrigger>
                <TabsTrigger
                    value="free"
                    className="rounded-none border-b-2 border-transparent data-[state=active]:border-indigo-600 data-[state=active]:bg-transparent data-[state=active]:shadow-none bg-transparent px-4 py-3 text-gray-500 data-[state=active]:text-indigo-600 font-normal data-[state=active]:font-semibold"
                >
                    Free Orders
                </TabsTrigger>
            </TabsList>
        </Tabs>
    );
};

